<div class="container">
    <mat-dialog-content><span [ngClass]="onDiscount() ? 'subtitle' : ''">{{ data.subTitle }}</span></mat-dialog-content>
    <mat-dialog-content *ngIf="data.title"><b style="text-align: center;">{{ data.title }} !!!</b></mat-dialog-content>
    <mat-dialog-actions align="end">
        <button class="yesbtn" (click) = "onYesClick()">{{ 'myprofile.myaddress.label.proceed' | translate}}</button>
    </mat-dialog-actions>
</div>